jQuery(document).ready(function ($) {

    $("#share-class").on("change", function () {
        var price = $(this).find('option:selected').data("price");
        var date  = $(this).find('option:selected').data("date");

        $("#nav-price").text("$" + price);
        $("#nav-date").text(date);
    });

    // ✅ Trigger default selection on page load
    $("#share-class").trigger("change");
});
